import { useEffect, useState } from "react";
import { consentState, setConsent } from "@/lib/pixels";

/**
 * Minimal GDPR cookie banner. Visible until the user accepts or declines.
 * Zero cost when env vars are empty (both pixels disabled → nothing to gate).
 */
export default function CookieConsent() {
  const [choice, setChoice] = useState(() => consentState());
  // TikTok Pixel is now hardcoded in index.html — the banner must always
  // appear for new visitors so they can grant/deny marketing cookies.
  useEffect(() => {}, []);
  if (choice) return null;
  const pick = (v) => { setConsent(v); setChoice(v); };
  return (
    <div
      role="dialog"
      aria-label="Consenso cookie"
      data-testid="cookie-consent"
      className="fixed z-[60] bottom-4 inset-x-4 md:left-auto md:right-4 md:bottom-4 md:w-96 rounded-xl border border-white/[0.08] bg-[#0C111B]/95 backdrop-blur-md shadow-2xl p-4 animate-[fadeInUp_0.3s_ease-out]"
    >
      <p className="text-xs text-slate-300 mb-3 leading-relaxed">
        Usiamo cookie di marketing per misurare le campagne (Meta &amp; TikTok). Puoi accettare o rifiutare in qualsiasi momento.
      </p>
      <div className="flex gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => pick("granted")}
          className="flex-1 h-9 rounded-lg bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white text-xs font-semibold"
        >Accetta</button>
        <button
          data-testid="cookie-decline"
          onClick={() => pick("denied")}
          className="h-9 px-4 rounded-lg border border-white/[0.08] text-slate-300 text-xs"
        >Rifiuta</button>
      </div>
    </div>
  );
}
